/*

dev_startup_ecom_1.5.9

Moving to v1.5.9
changes: from v1.5.8 to v1.5.9

What feature added:

1. Bulk Product Import


*/


import React from 'react';
import './App.css';
import { Routes, Route } from 'react-router-dom';
import { useAuth } from './context/AuthContext';

import Success from './pages/Success';
import ShoppingCart from './pages/ShoppingCart';
import OrderSummary from './pages/OrderSummary';
import Login from './pages/Login';
import Register from './pages/Register';
import ShippingAddress from './pages/ShippingAddress';
import ShippingRoute from './pages/ShippingRoute';
import ShippingDisplay from './pages/ShippingDisplay';
import Products from './pages/Products';
import PricingPage from "./pages/PricingPage";

import AddProduct from './pages/admin/AddProduct';
import AdminNewsletter from "./pages/admin/AdminNewsletter";
import Sale from "./pages/Sale";
import NewArrivals from "./pages/NewArrivals";
import BestSeller from "./pages/BestSellers";



import AdminOrdersPage from './pages/admin/AdminOrdersPage';
import CustomersPage from './pages/admin/CustomersPage';
import AdminMainPage from './pages/admin/AdminMainPage';
import ProductList from './pages/admin/ProductList';
import EditProduct from './pages/admin/EditProduct';
import AdminBulkUpload from './pages/admin/AdminBulkUpload';
import Banners from './pages/admin/Banners';

import ProductDetails from './components/ProductDetails';
import Footer from './components/Footer';
import MyOrders from './components/MyOrders';
import NotFound from './pages/NotFound';
import NavBar from './components/NavBar';
import Docs from './components/Docs';
import PlanAndPrice from './components/PlanAndPrice';
import FixPrice from './components/FixPrice';
import StartupPricingPage from './components/StartupPricingPage';
import ProtectedRoute from './components/ProtectedRoute';
import SelectCheckout from './components/SelectCheckout';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';

function App() {
  const { authLoaded } = useAuth();

  if (!authLoaded) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
        <span>Loading...</span>
      </div>
    );
  }

  return (
    <div className="app-wrapper" style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <NavBar />

      <div style={{ flex: 1 }}>
        <Routes>

          {/* PUBLIC */}
          <Route path="/" element={<Products />} />
          <Route path="/products" element={<Products />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/docs" element={<Docs />} />
          <Route path="/planandprice" element={<PlanAndPrice />} />
          <Route path="/fixprice" element={<FixPrice />} />
          <Route path="/startupprice" element={<StartupPricingPage />} />
          <Route path="/product/:id" element={<ProductDetails />} />
          <Route path="/cart" element={<ShoppingCart />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password/:token" element={<ResetPassword />} />
          <Route path="/sale" element={<Sale />}/>
          <Route path="/new-arrivals" element={<NewArrivals />}/>
          <Route path="/best-sellers" element={<BestSeller />} />


          {/* USER (NON-ADMIN) */}

          <Route
            path="/order-summary"
            element={
              <ProtectedRoute>
                <OrderSummary />
              </ProtectedRoute>
            }
          />


          <Route
            path="/PricingPage"
            element={
              <ProtectedRoute>
                <PricingPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/selectcheckout"
            element={
              <ProtectedRoute>
                <SelectCheckout />
              </ProtectedRoute>
            }
          />

          <Route
            path="/shipping"
            element={
              <ProtectedRoute>
                <ShippingRoute />
              </ProtectedRoute>
            }
          />

          <Route
            path="/shippingaddress"
            element={
              <ProtectedRoute>
                <ShippingAddress />
              </ProtectedRoute>
            }
          />

          <Route
            path="/shipping/display"
            element={
              <ProtectedRoute>
                <ShippingDisplay />
              </ProtectedRoute>
            }
          />

          <Route
            path="/success"
            element={
              <ProtectedRoute>
                <Success />
              </ProtectedRoute>
            }
          />

          <Route
            path="/my-orders"
            element={
              <ProtectedRoute>
                <MyOrders />
              </ProtectedRoute>
            }
          />

          {/* ADMIN ONLY */}
          <Route
            path="/admin/orders"
            element={
              <ProtectedRoute adminOnly={true}>
                <AdminOrdersPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admin/newsletter"
             element={<AdminNewsletter/>}
          />


          <Route
            path="/admin/bulk-upload"
            element={<AdminBulkUpload />}
          />

          <Route
          path="/admin/banners"
          element={
              <ProtectedRoute adminOnly={true}>
                <Banners />
              </ProtectedRoute>  
                }
          />


          <Route
            path="/admin/main"
            element={
              <ProtectedRoute adminOnly={true}>
                <AdminMainPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admin/customers"
            element={
              <ProtectedRoute adminOnly={true}>
                <CustomersPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/addproduct"
            element={
              <ProtectedRoute adminOnly={true}>
                <AddProduct />
              </ProtectedRoute>
            }
          />

          <Route
            path="/productlist"
            element={
              <ProtectedRoute adminOnly={true}>
                <ProductList />
              </ProtectedRoute>
            }
          />

          <Route
            path="/edit/:id"
            element={
              <ProtectedRoute adminOnly={true}>
                <EditProduct />
              </ProtectedRoute>
            }
          />

          {/* FALLBACK */}
          <Route path="*" element={<NotFound />} />

        </Routes>
      </div>

      <Footer />
    </div>
  );
}

export default App;
